import React, { useState } from 'react';
import { DEFAULT_CHANNEL_SETTING } from '@sonifi/wb-admin/constants/wbAdminConstants';

const HappeningsChannel = ({ getValues, setValue, register, errors }) => {
  const numberOfChannels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [showChannelList, setShowChannelList] = useState(true);
  const toggleShowChannelList = () => setShowChannelList(!showChannelList);
  const defaultActiveTimeSupport =
    getValues('products.happenings_channel.settings.active_time_support') ||
    'day_of_month';
  const defaultNumberOfChannels =
    getValues('products.happenings_channel.settings.number_of_channels') || 1;
  const platform = getValues('group.platform');
  const handleChannelSettingsChange = (numberOfChannels) => {
    const channel_settings = new Array(numberOfChannels).fill(
      DEFAULT_CHANNEL_SETTING,
    );

    const currentChannelSettings = getValues(
      'products.happenings_channel.settings.channel_settings',
    );

    const new_channel_settings = [];

    channel_settings.forEach((ch, index) => {
      const channelWithLabel = {
        ...ch,
        label: currentChannelSettings[index]?.label,
      };
      new_channel_settings.push(channelWithLabel);
    });

    setValue(
      'products.happenings_channel.settings.channel_settings',
      new_channel_settings,
    );
  };

  const handleChannelTimeChange = (i, v) => {
    setValue(
      `products.happenings_channel.settings.channel_settings.${i}.duration_limit`,
      v * 60,
    );
  };

  const handleChannelLabelChange = (i, v) => {
    setValue(
      `products.happenings_channel.settings.channel_settings.${i}.label`,
      v,
    );
  };

  const validateLabelField = (value, formValues) => {
    if (value === '') {
      return;
    }
    const settings =
      formValues?.products?.happenings_channel?.settings?.channel_settings;

    return (
      settings.filter((val) => val.label === value).length < 2 ||
      'values must be different'
    );
  };

  return (
    <section
      ng-controller="wbHappeningsProductSettingsCtrl as happeningsCtrl"
      className="no-max-height"
    >
      <div className="row">
        <label className="col-md-3 control-label">Active Time Support</label>
        <div className="col-md-3">
          <select
            className="form-control"
            defaultValue={defaultActiveTimeSupport}
            {...register(
              'products.happenings_channel.settings.active_time_support',
            )}
          >
            <option value="day_of_month">Full (Marina 11.0 and higher)</option>
            <option value="always_active">None (Marina 10.3 and lower)</option>
          </select>
        </div>
      </div>
      <br />

      <div className="row">
        <label className="col-md-3 control-label">
          Number of {platform !== 'Ocean' ? 'Channels' : 'Videos'}
        </label>
        <div className="col-md-2">
          <select
            className="form-control"
            defaultValue={defaultNumberOfChannels}
            {...register(
              'products.happenings_channel.settings.number_of_channels',
              {
                valueAsNumber: true,
              },
            )}
            onChange={(e) =>
              handleChannelSettingsChange(parseInt(e.target.value))
            }
          >
            {numberOfChannels?.map((n) => (
              <option key={`channel${n}`} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>
      <br />

      {defaultNumberOfChannels !== 0 && (
        <div className="happenings-settings-channel-list">
          <label
            className={`expandable-list-header col-md-3 control-label${
              !showChannelList ? ' collapsed' : ''
            }`}
            onClick={toggleShowChannelList}
          >
            {platform !== 'Ocean' ? 'Channel List' : 'Video List'}
          </label>

          {showChannelList && (
            <section className="no-max-height">
              <table className="form-section">
                <tbody>
                  {getValues(
                    'products.happenings_channel.settings.channel_settings',
                  )?.map((c, i) => (
                    <tr key={`channel${i}`}>
                      <td>
                        Happenings {platform !== 'Ocean' ? 'Channel' : 'Video'}{' '}
                        {i + 1}
                      </td>
                      <td>
                        <div className="input-channel-label">
                          <input
                            value={c.label || ''}
                            placeholder="Enter Optional Channel Display Name"
                            type="text"
                            className={
                              errors?.products?.happenings_channel?.settings
                                .channel_settings[i]
                                ? 'wb-invalid'
                                : ''
                            }
                            max="38"
                            {...register(
                              `products.happenings_channel.settings.channel_settings.${i}.label`,
                              {
                                onChange: (e) => {
                                  handleChannelLabelChange(i, e.target.value);
                                },
                                validate: validateLabelField,
                              },
                            )}
                          />
                          {errors?.products?.happenings_channel?.settings
                            .channel_settings[i]?.label ? (
                            <p className="error">
                              {
                                errors.products.happenings_channel.settings
                                  .channel_settings[i].label.message
                              }
                            </p>
                          ) : null}
                        </div>
                      </td>
                      <td>
                        <span>Time limit</span>
                        <input
                          value={c.duration_limit / 60}
                          onChange={(e) =>
                            handleChannelTimeChange(i, parseInt(e.target.value))
                          }
                          max="400"
                          min="0"
                          required
                          type="number"
                          className="form-control"
                        />
                        <span>minutes</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div>
                <label className="control-label">Time Limit Total</label>
                <br />
                <div>
                  <input
                    value={
                      getValues(
                        'products.happenings_channel.settings.channel_settings',
                      )?.reduce((acc, c) => acc + c.duration_limit, 0) / 60
                    }
                    max="400"
                    min="0"
                    type="number"
                    disabled
                    className="form-control"
                    id="duration-limit-total"
                    title="400 minute max"
                  />
                  <span>minutes</span>
                </div>
              </div>
            </section>
          )}
        </div>
      )}
    </section>
  );
};

export default HappeningsChannel;
